<template>
  <nav class="navbar min-w-1400">
    <div
      class="secondBox max-w-1400"
      :class="{
        'secondBox-bottom':
          $route.path === '/question' || $route.path === '/protocol',
      }"
    >
      <router-link to="/" class="logo">
        
        <img
          :src="logoImg"
          :alt="logoAlt"
          class="logoImg"
        />
      </router-link>

      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Sản phẩm</span>
          </router-link>
        </li>

        <li
          :class="{
            'active-link':
              $route.path.startsWith('/about') ||
              $route.path.startsWith('/news') ||
              $route.path.startsWith('/promotion'),
          }"
          class="Li2 header-dropdown"
        >
          <div class="nav-link2 header-dropdown-toggle">
            <span class="routeText2">Tin tức & Khuyến mãi</span>
            <span class="header-dropdown-arrow">&#9662;</span>
          </div>

          <ul class="header-dropdown-menu">
            <li :class="{ 'active-sublink': $route.path === '/about' }">
              <router-link to="/about" class="header-dropdown-item">
                <span>Khuyến mãi</span>
              </router-link>
            </li>
            <li :class="{ 'active-sublink': $route.path === '/news' }">
              <router-link to="/news" class="header-dropdown-item">
                <span>Kiến thức tài chính</span>
              </router-link>
            </li>
          </ul>
        </li>

        <li :class="{ 'active-link': $route.path === '/question' }" class="Li3">
          <router-link to="/question" class="nav-link3">
            <span class="routeText3">Văn hóa Lavi</span>
          </router-link>
        </li>

        <li :class="{ 'active-link': isProtocolActive }" class="Li4 header-dropdown">
          <div class="nav-link4 header-dropdown-toggle">
            <span class="routeText4">Trung tâm pháp lý</span>
            <span class="header-dropdown-arrow header-dropdown-arrow--dark">
              &#9662;
            </span>
          </div>

          <ul class="header-dropdown-menu">
            <li :class="{ 'active-sublink': $route.path === '/privacy' }">
              <router-link to="/privacy" class="header-dropdown-item">
                <span>Chính sách bảo mật</span>
              </router-link>
            </li>
            <li :class="{ 'active-sublink': $route.path === '/protocol' }">
              <router-link to="/protocol" class="header-dropdown-item">
                <span>Điều khoản dịch vụ</span>
              </router-link>
            </li>
          </ul>
        </li>

        <li :class="{ 'active-link': $route.path === '/download' }" class="Li5">
          <router-link to="/download" class="nav-link5">
            <span class="routeText5">Tải ứng dụng</span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import logoImg from "@/page/lavifinancecompany/components/img/logo.png";

export default {
  data() {
    return {
      link1Color: "white",
      logoImg,
      logoAlt: "Lavi Finance",
    };
  },
  computed: {
    isProtocolActive() {
      return (
        this.$route.path === "/protocol" ||
        this.$route.path === "/faq" ||
        this.$route.path === "/contact" ||
        this.$route.path === "/privacy" ||
        this.$route.path === "/protocol"
      );
    },
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px 0 50px;
  background-color: #ffffff;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  height: 80px;
  margin-left: 30px;
}

.title {
  width: 550px;
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #333333;
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-links li {
  display: flex;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 6px;
  height: 39px;
}

.Li1 {
  width: 150px;
}

.Li2 {
  width: 200px;
}

.Li3 {
  width: 210px;
}

.Li4 {
  width: 250px;
}

.Li5 {
  width: 150px;
}

.active-link {
  border-color: #244ee8;
  background-color: #244ee8;
  border-radius: 76px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;
  color: #ffffff;
}

.header-dropdown {
  position: relative;
  cursor: pointer;
}

.header-dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
}

.header-dropdown-toggle::after {
  display: none;
}

.header-dropdown-arrow {
  font-size: 10px;
  line-height: 1;
  transition: transform 0.3s ease;
}

.header-dropdown-arrow--dark {
  color: #333333;
}

.header-dropdown:hover .header-dropdown-arrow {
  transform: rotate(180deg);
}

.header-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: block;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  list-style: none;
  padding: 8px 0;
  margin: 5px 0 0 0;
  min-width: 180px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1001;
}

.header-dropdown:hover .header-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.header-dropdown-menu li {
  display: block;
  height: auto;
  padding: 0;
  background: none;
}

.header-dropdown-item {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: #333333;
  font-size: 14px;
  font-family: SF Pro-Semibold;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.header-dropdown-item:hover {
  background-color: #f5f5f5;
}

.active-sublink .header-dropdown-item {
  color: #244ee8;
  font-weight: 600;
}
</style>
